import { imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import { contentStyles, h5 } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.div `
  min-height: 100px;
  overflow: hidden;
  padding: 0;
  color: var(--widgetFgColour);

  &[data-alignment='center'] {
    text-align: center;
  }

  ${ButtonStyles.Container} {
    --buttonHeight: ${fluid(44, 48)};
    position: relative;
    align-self: flex-start;
  }
`;
const Grid = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;

  [data-is-numbered='true'] & {
    @media ${until(Device.Tablet)} {
      flex-direction: row;
      align-items: center;
      gap: 16px;
    }
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(1, 1)};

  width: ${fluid(56, 88)};
  height: ${fluid(56, 88)};
  margin-bottom: 16px;

  &:has(${() => Number}) {
    display: grid;
    place-content: center;
  }

  [data-small-icon='true'] & {
    @media ${until(Device.Tablet)} {
      width: 44px;
      height: 44px;
    }
  }

  [data-alignment='center'] & {
    margin-left: auto;
    margin-right: auto;
  }
`;
const Image = styled.img `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
`;
const Number = styled.span `
  ${fonts.intro};
  width: ${fluid(64, 88)};
  height: ${fluid(64, 88)};
  background-color: var(--widgetFgColour);
  color: var(--widgetNumberColour);
  font-size: ${fluid(32, 50)};
  line-height: ${fluid(64, 88)};
  border-radius: 50%;
  display: grid;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  @media ${until(Device.Tablet)} {
    flex: 0 0 ${fluid(64, 88)};
  }
`;
const ContentArea = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const Heading = styled.h3 `
  ${h5}
  ${fonts.lato.semiBold};

  margin-bottom: ${fluid(8, 12)};
`;
const CtaArea = styled.div `
  margin-top: auto;

  [data-alignment='center'] & {
    margin-left: auto;
    margin-right: auto;
  }
`;
const Content = styled.div `
  ${contentStyles};

  a {
    color: var(--widgetFgColour);
  }

  li,
  p {
    font-size: ${fluid(14, 16)};
    line-height: ${fluid(22, 24)};

    a {
      color: var(--widgetFgColour);
    }
  }

  ${ContentArea}:has(${CtaArea}) & {
    margin-bottom: 16px;
  }
`;
const UspCardStyles = {
    Container,
    Content,
    ContentArea,
    CtaArea,
    Grid,
    Heading,
    ImageContainer,
    Image,
    Number,
};
export default UspCardStyles;
